import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { SnackbarTypes } from 'src/app/core/_enums/snackbar.types';
import { SnackbarService } from 'src/app/core/_services/snackbar.service';
import { ConfirmCancelDialogComponent } from '../confirm-cancel-dialog/confirm-cancel-dialog.component';

export class ImportSeveFileDialogData {
  perimeterId?: string;
}

@Component({
  selector: 'app-dialog-import-seve-file',
  templateUrl: './dialog-import-seve-file.component.html',
  styleUrls: ['./dialog-import-seve-file.component.scss']
})
export class DialogImportSeveFileComponent {
  dialogData: ImportSeveFileDialogData = new ImportSeveFileDialogData();
  selectedFile: File | null = null;
  fileName: string = '';
  formatError: boolean = false;
  isLoading: boolean = false;
  apiError: string = '';

  constructor(
    public importDialogRef: MatDialogRef<DialogImportSeveFileComponent>,
    private snackbarService: SnackbarService,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private translate: TranslateService
  ) {
    if (data) {
      this.initialize(data);
    }
  }

  initialize(data: any) {
    this.dialogData.perimeterId = data.perimeterId;
  }

  onFileSelected(event: any) {
    const file = event.target.files[0];
    if (file) {
      const fileExtension = file.name.split('.').pop()?.toLowerCase();
      if (fileExtension === 'sevetp') {
        this.selectedFile = file;
        this.fileName = file.name;
        this.formatError = false;
        this.apiError = '';
      } else {
        this.formatError = true;
        this.apiError = '';
        this.selectedFile = null;
        this.fileName = '';
        const fileInput = document.getElementById('fileInput') as HTMLInputElement;
        if (fileInput) {
          fileInput.value = '';
        }
      }
    }
  }

  onRemoveFile() {
    this.selectedFile = null;
    this.fileName = '';
    this.formatError = false;
    this.apiError = '';
    const fileInput = document.getElementById('fileInput') as HTMLInputElement;
    if (fileInput) {
      fileInput.value = '';
    }
  }

  onImport() {
    if (!this.selectedFile) {
      this.snackbarService.open(SnackbarTypes.error, this.translate.instant('error_select_file'));
      return;
    }

    this.isLoading = true;
    this.apiError = '';

    this.importDialogRef.close({ success: true, file: this.selectedFile, stopLoading: () => (this.isLoading = false) });
  }

  onCancel() {
    if (this.selectedFile) {
      const confirmDialog = this.dialog.open(ConfirmCancelDialogComponent, {
        data: {
          message: this.translate.instant('confirm_cancel_import_file'),
          confirmText: this.translate.instant('yes_cancel_import'),
          cancelText: this.translate.instant('continue_import'),
          confirmColor: 'warn'
        }
      });

      confirmDialog.afterClosed().subscribe((result) => {
        if (result) {
          this.importDialogRef.close();
        }
      });
    } else {
      this.importDialogRef.close();
    }
  }

  canImport(): boolean {
    return this.selectedFile !== null;
  }
}
